import { MouseEvent } from 'react';

import Button from '@/components/common/Button';

type Props = {
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
};

const Search = ({ onClick }: Props) => {
  return (
    <Button className="btn_search" onClick={onClick}>
      <span className="ico_wallet ico_search">검색</span>
    </Button>
  );
};

export default Search;
